import { render, staticRenderFns } from "./copyPrescriptionDialog.vue?vue&type=template&id=569b2dd2&scoped=true"
import script from "./copyPrescriptionDialog.vue?vue&type=script&lang=ts"
export * from "./copyPrescriptionDialog.vue?vue&type=script&lang=ts"
import style0 from "./copyPrescriptionDialog.vue?vue&type=style&index=0&id=569b2dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569b2dd2",
  null
  
)

export default component.exports